export default function() {
    jQuery('.menu-item-has-children').on('click', function(event) {
        jQuery(this).toggleClass('menu-item-expanded');
        jQuery(this).find('.sub-menu').slideToggle(300);
    });

    jQuery('.js-header--mobile-menu-toggle').on('click', function() {
        jQuery('.js-header--mobile-menu').slideToggle(300);
        jQuery(this).toggleClass('active');
    });
}